/**
 * SANAL HESAP SINIRLARI (gelir modeli, kullanıcı kararı 20.10.2026):
 * ücretsizde yok; geçiş paketinde 1, sonrakiler üçlü paket; B tipi (gerçek
 * hesapların para akışı), dengeleme ve paylaşım ayrı kabiliyetler. Hakkı
 * olmayan kasada paylaşılan kural EKLENMEZ, özeti gösterilir.
 *
 * Var olan sanal hesaplar silinmez ve görünür; sınır yalnızca YENİ eklemeyi
 * ve kilitli seçeneğe geçmeyi durdurur.
 */

import type { Sinirlar } from "@parafon/contracts/sertifika";
import { M } from "../dil";

export interface SanalKuralOzeti {
  /** Düzenlemede var olan kimlik; yeni hesapta yok ya da boş. */
  readonly id?: string | null;
  readonly paraAkisi: { readonly tur: string };
  readonly dengeleme: string;
}

/** Kaydetme engeli: kilitli olan şeyin adı (kilit ifadesinde), yoksa `null`. */
export function sanalKilidi(
  g: SanalKuralOzeti,
  s: Pick<Sinirlar, "sanalHesap" | "sanalB" | "sanalDengeleme">,
  mevcutSayi: number,
  onceki: SanalKuralOzeti | null = null,
): string | null {
  const yeni = g.id === undefined || g.id === null || g.id === "";
  if (yeni && s.sanalHesap !== null && mevcutSayi >= s.sanalHesap) {
    return s.sanalHesap === 0 ? M.ayarlar.kilit.sanalHesap : M.ayarlar.kilit.sanalFazlasi(s.sanalHesap);
  }
  // Var olan bir kuralda zaten seçili olan kilitli seçenek düzenlemeyi
  // durdurmaz (kayıt silinmez); yalnızca kilitli seçeneğe GEÇMEK durur.
  const bOnceden = onceki?.paraAkisi.tur === "defter";
  const dOnceden = onceki !== null && onceki.dengeleme !== "yok";
  if (g.paraAkisi.tur === "defter" && !s.sanalB && !bOnceden) return M.ayarlar.kilit.sanalB;
  if (g.dengeleme !== "yok" && !s.sanalDengeleme && !dOnceden) return M.ayarlar.kilit.dengeleme;
  return null;
}
